export default {
  // Tabs
  customModelsTab: 'Modelos Personalizados',
  adHocModelsTab: 'Modelos Ad-Hoc',
  automaticModelsTab: 'Modelos DIY',
  metadataTab: 'Metadados',
  channelTaxonomyTab: 'Taxonomia de Canais',
  deletedModelsTab: 'Modelos excluídos',
  errorDeletingModel: 'Erro ao excluir o modelo',
  errorDeletingSomeModels: 'Não foi possível excluir {count} modelos',

  // Delete selected models dialog
  deleteSelectedTitle: 'Excluir os modelos selecionados?',
  deleteSelectedMessage: 'Você está prestes a excluir os seguintes ({count}) modelos:',
  deleteSelectedConfirm: 'Tem certeza?',
  deleteSelectedWarning: 'Você poderá recuperá-los durante 7 dias solicitando a um administrador.',
  deleteSelectedInputLabel: "digite 'delete' aqui para habilitar o botão Excluir Modelos",
  deleteModelsButton: 'Excluir modelos',

  // Delete single model dialog
  warningTitle: 'Aviso',
  deleteModelMessage: 'Excluindo modelo: {name}',
  deleteModelConfirm: 'Você poderá recuperá-lo durante 7 dias solicitando a um administrador. Tem certeza?',

  // Buttons
  createCustomModel: 'Criar Modelo Personalizado',
  deleteSelectedModels: 'Excluir modelos selecionados',
  cancel: 'Cancelar',
  delete: 'Excluir',
  close: 'Fechar',

  // Search
  search: 'Buscar',

  // Custom Models table headers
  headerName: 'Nome',
  headerType: 'Tipo',
  headerCategory: 'Categoria',
  headerReference: 'Referência',
  headerMonthlySpend: 'Gasto',
  headerMonthlySales: 'Vendas',
  headerCountry: 'País',
  headerQuality: 'Qualidade',
  headerModified: 'Modificado',
  headerCreator: 'Criador',
  headerActions: 'Ações',

  // Edit name
  editLabel: 'Editar',
  inputTooLong: 'Entrada muito longa!',

  // Action tooltips
  recalculateModelReport: 'Recalcular Relatório do Modelo',
  clone: 'Clonar',
  deleteModel: 'Excluir Modelo',
  printJsonToConsole: 'Imprimir JSON no console',
  importPlans: 'Importar Planos',
  modelSettings: 'Configurações do Modelo',
  modelData: 'Dados do Modelo',

  // Snackbar messages
  modelRenamed: 'Modelo renomeado',
  errorRenamingModel: 'Erro ao renomear o modelo',
  idCopied: 'ID copiado para a área de transferência!',

  // Model type labels (Metadata tab)
  typeCustomReference: 'Personalizado Ref.',
  typeCustomEkrm: 'Personalizado EKRM',
  typeAdHoc: 'Ad-Hoc',
  typeDiy: 'DIY',

  // Type column filter (Metadata tab)
  filterSelectAll: 'Selecionar tudo',
  filterNone: '(nenhum)',

  // Client-metadata columns (Metadata tab)
  metaHeaderClient: 'Cliente',
  metaHeaderBrand: 'Marca',
  metaHeaderCategory: 'Categoria',
  metaHeaderSubCategory: 'Subcategoria',
  metaHeaderCountry: 'País',

  // Channel Taxonomy tab
  taxonomyHeaderModel: 'Modelo',
  taxonomyHeaderChannel: 'Canal',
  taxonomyHeaderCode: 'Taxonomia',
  taxonomyExportCsv: 'Exportar CSV',
  taxonomyCodeCopied: 'Código de taxonomia copiado para a área de transferência!',

  // Ad-Hoc tab filters
  selectAllVisible: 'Selecionar Todos os Visíveis ({count})',
  allCountries: 'Todos os países',
  countriesSelected: '{count} de {total} países selecionados',
  filterByCountry: 'Filtrar por País',
  searchCountries: 'Buscar países',
  allBrands: 'Todas as marcas',
  brandsSelected: '{count} de {total} marcas selecionadas',
  filterByBrand: 'Filtrar por Marca',
  searchBrands: 'Buscar marcas',
  allClients: 'Todos os clientes',
  clientsSelected: '{count} de {total} clientes selecionados',
  filterByClient: 'Filtrar por Cliente',
  searchClients: 'Buscar clientes',
  allCategories: 'Todas as categorias',
  categoriesSelected: '{count} de {total} categorias selecionadas',
  filterByCategory: 'Filtrar por Categoria',
  searchCategories: 'Buscar categorias',
  allSubcategories: 'Todas as subcategorias',
  subcategoriesSelected: '{count} de {total} subcategorias selecionadas',
  filterBySubcategory: 'Filtrar por Subcategoria',
  searchSubcategories: 'Buscar subcategorias',

  // Misc
  notAvailable: 'N/D',
  updating: '(Atualizando...)',
  // Versions
  current: 'atual',
  versionDeployed: 'Implantada em {date}'
}
